<template>
	<v-layout column>
		<v-subheader>
			Test envoi automatique
			<b-o-input
				ref="input"
				:input="{ type: 'date', label: isAsko ? 'Stérilisation' : 'inscription le' }"
				v-model="subscribAt"
			></b-o-input>
		</v-subheader>
		<div v-if="schedule" style="margin-left:30px;">
			<v-label>Nom de la liste : </v-label> {{ schedule.name }}
			<br />
			<span v-for="subBot in sortedBots" :key="`send${getBotId(subBot)}`">
				<v-label>{{ subBot.name }} :</v-label> {{ sendedAt(schedule.schedules[getBotId(subBot)]) }}
				<br />
			</span>
		</div>
	</v-layout>
</template>

<script>
import BOInput from '../../baseComponents/boInput.vue'

export default {
	components: { BOInput },
	props: ['subBots', 'scheduler', 'isAsko', 'botName'],
	data() {
		return {
			subscribAt: new Date(),
			schedule: null,
		}
	},
	mounted() {
		this.getSchedule()
	},
	watch: {
		subscribAt() {
			this.getSchedule()
		},
		scheduler: {
			deep: true,
			handler() {
				this.getSchedule()
			},
		},
	},
	computed: {
		getBotId() {
			return (subbot) => (!this.$route.params.botId ? subbot.name : subbot._id)
		},
		sortedBots() {
			const list = this.subBots
			const keys = Object.keys(this.schedule.schedules)
			return list
				? list
						.filter((subbot) => this.schedule.schedules[this.getBotId(subbot)])
						.sort(
							(subbot1, subbot2) =>
								keys.findIndex((_id) => _id === this.getBotId(subbot1)) -
								keys.findIndex((_id) => _id === this.getBotId(subbot2)),
						)
				: []
		},
		sendedAt() {
			return (schedule) => {
				const date = new Date(schedule.date)
				let day = { 0: 'DIM', 1: 'LUN', 2: 'MAR', 3: 'MER', 4: 'JEU', 5: 'VEN', 6: 'SAM' }[date.getDay()]
				let res = `${day} ${this.$options.filters.formatDate(date)}`
				if (schedule.hour || schedule.minutes) {
					res += ` à ${schedule.hour} h ${schedule.minutes ? schedule.minutes : '00'} min`
				}
				if (schedule.filters) {
					res += ` filtrer par ${schedule.filters}`
				}
				return res
			}
		},
	},
	methods: {
		async getSchedule() {
			if (this.scheduler) {
				const res = await this.axios.post(`/bots/${this.$route.params.botId}/scheduler`, {
					from: this.subscribAt,
					scheduler: this.scheduler,
					theme: this.scheduler.theme,
					isAsko: this.isAsko,
					botName: this.botName,
				})
				this.schedule = res.data
			}
		},
	},
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/bots/test.scheduler.vue